import { HttpService } from './http.service';

const ArticleService = {
  ARTICLE_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  getArticle(slug) {
    return HttpService.httpGet(`${this.ARTICLE_API_HOST}/api/articles/view/${slug}`)
        .then(article => this.setContent(article));
  },

  getByCategory(categoryId) {
    return HttpService.httpGet(`${this.ARTICLE_API_HOST}/api/category/${categoryId}/articles`)
        .then(articles => articles.map(article => this.setContent(article)));
  },

  getRelatedArticles(slugs) {
    return HttpService.httpGet(`${this.ARTICLE_API_HOST}/api/related-articles/view`, { slugs: slugs })
        .then(articles => articles.map(article => this.setContent(article)));
  },

  getFeaturedArticles() {
    return HttpService.httpGet(`${this.ARTICLE_API_HOST}/api/articles/featured`)
        .then(articles => articles.map(article => this.setContent(article)));
  },

  setContent (article) {
    // add a regex escape function to escape special characters
    RegExp.escape = function (s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };

    // get the decoded values
    const parser = new DOMParser();
    const doc = parser.parseFromString(article.content.trim(), 'text/html');
    const elem = doc.firstChild;

    let headers = elem.getElementsByClassName('section-header');

    for (let header of headers) {
      header.id = header.innerHTML.replace(new RegExp(/\s+/, 'g'), '-').toLowerCase();
    }

    // find all paragraphs
    let paragraphs = elem.getElementsByTagName('p');

    let terms = article.glossary_terms.slice();

    // order glossary terms from largest to smallest
    terms.sort(function (a, b) {
      return b.term.length - a.term.length;
    });

    // go through each term and replace with glossary term.
    terms.forEach((term) => {
      let matched = false;
      const escapedTerm = RegExp.escape(term.term);
      const title = term.description;
      const re = new RegExp('\\b' + escapedTerm + '(?!\\w)','i');

      // make sure the element is a paragraph and is not a header and is directly in a column
      for (let paragraph of paragraphs){
        if (this.elementCanContainGlossaryTerms(paragraph)){

          // find all the text nodes to prevent breaking element nodes
          for (let childNode of paragraph.childNodes){
            if (childNode.nodeType === 3 && re.test(childNode.nodeValue)){

              let match = re.exec(childNode.textContent);
              let replacementNode = childNode.splitText(match.index);

              // create the glossary button to be input
              let glossaryButton = document.createElement('span');
              glossaryButton.className = 'glossary-term';
              glossaryButton.setAttribute('data-title', title);
              glossaryButton.setAttribute('tabIndex', '-1');
              glossaryButton.appendChild(document.createTextNode(match[0]));

              paragraph.insertBefore(glossaryButton, replacementNode);

              replacementNode.nodeValue = replacementNode.nodeValue.slice(match[0].length);

              matched = true;
              break;
            }
          }
          // stop iterating through paragraphs if term is found
          if (matched) break;
        }
      }
    });

    article.content = elem.innerHTML.toString();

    return article;
  },

  elementCanContainGlossaryTerms(element) {
    return (element.className === '' || element.className === 'section-intro') &&
      (element.parentElement.tagName.toLowerCase() === 'div' || element.parentElement.tagName.toLowerCase() === 'blockquote') &&
      !element.parentElement.classList.contains('sidebar-boxed')
  }
};

export default ArticleService
